import React from 'react'
import Header from './Header'
import Footer from './Footer'

const Terms = () => {
  return (
    <> 
    <Header/>
    <section class="bg-gradient-to-br from-brand to-brand-dark text-gray-700 mt-20">
    <div class="max-w-6xl mx-auto px-6 py-14">
      <p class="uppercase tracking-widest text-brand-light/90 text-xs font-semibold mb-3">Legal Agreement</p>
      <h1 class="text-3xl sm:text-4xl font-extrabold leading-tight">Terms &amp; Conditions</h1>
      <p class="mt-4 max-w-2xl text-gray/85 text-sm sm:text-base">
        These Terms govern your access to and use of the Beeppee mobile application, website, tracking
        technology, connected services and related features.
      </p>
      <div class="mt-6 flex flex-wrap gap-4 text-sm text-gray/90">
        <div><span class="font-semibold text-gray">Effective Date:</span> 13/10/2026</div>
        <div><span class="font-semibold text-gray">Last Updated:</span> 13/10/2026</div>
      </div>
    </div>
  </section>
 

  <section class="bg-white border-b border-slate-200">
    <div class="max-w-6xl mx-auto px-6 py-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 text-sm">
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Registered Company</p>
        <p class="font-medium text-slate-800">Beeppoint solutions limited</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">CAC Registration No.</p>
        <p class="font-medium text-slate-800">RC:2015999</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Trading Name</p>
        <p class="font-medium text-slate-800">Beeppee</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Country of Registration</p>
        <p class="font-medium text-slate-800">Federal Republic of Nigeria</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Customer Support</p>
        <p class="font-medium text-slate-800">info@beeppee.com</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Telephone</p>
        <p class="font-medium text-slate-800">+234 916 338 5136</p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Registered Address</p>
        <p class="font-medium text-slate-800"></p>
      </div>
      <div>
        <p class="text-slate-400 text-xs uppercase tracking-wide">Website</p>
        <p class="font-medium text-slate-800">Beeppee.com</p>
      </div>
    </div>
  </section>
 
 
  <div class="max-w-6xl mx-auto px-6 py-10 flex flex-col lg:flex-row gap-10">
 
   
    <aside class="lg:w-72 shrink-0">
      <div class="lg:sticky lg:top-24 bg-white border border-slate-200 rounded-2xl p-5 max-h-[75vh] overflow-y-auto">
        <p class="text-xs font-semibold uppercase tracking-wide text-slate-400 mb-3">Table of Contents</p>
        <nav class="space-y-1 text-sm" id="toc"></nav>
      </div>
    </aside>
 
    
    <main class="flex-1 min-w-0 space-y-10">
 
     
      <div class="bg-amber-50 border border-amber-300 rounded-2xl p-5 flex gap-4">
        <div class="shrink-0 w-9 h-9 rounded-full bg-amber-400 text-white flex items-center justify-center font-bold">!</div>
        <div class="text-sm text-amber-900 leading-relaxed">
          <p class="font-bold mb-1">Important Safety Notice</p>
          <p>Beeppee is a technology platform and not an emergency-response organization. Do not rely
          solely on Beeppee for emergency response, medical assistance, law-enforcement response,
          personal protection, theft prevention or recovery of a person or property. Where immediate
          assistance is required, contact the appropriate emergency or professional service.</p>
        </div>
      </div>
 
   
      <section id="s1" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">1. About These Terms</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>These Terms and Conditions ("Terms") govern your access to and use of the Beeppee mobile application, website, software, tracking technology, connected services, features and related services (collectively, the "Services").</li>
          <li>By downloading, installing, registering for, accessing or using Beeppee, you agree to these Terms and the Beeppee Privacy Policy.</li>
          <li>If you do not agree to these Terms, you must not use the Services.</li>
          <li>These Terms form a legally binding agreement between you and the Beeppee entity identified above ("Beeppee", "we", "us" or "our").</li>
          <li>If you use Beeppee on behalf of a company, employer, organization or other legal entity, you confirm that you have authority to bind that entity.</li>
        </ol>
      </section>
 
     
      <section id="s2" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">2. Definitions</h2>
        <p class="text-sm text-slate-500 mb-4">For these Terms:</p>
        <dl class="divide-y divide-slate-100 text-sm">
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Account</dt><dd class="sm:col-span-3 text-slate-700">Means a registered Beeppee user account.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Beeppee Credits</dt><dd class="sm:col-span-3 text-slate-700">Means prepaid or otherwise allocated units that may be used to access chargeable Beeppee features.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Business User</dt><dd class="sm:col-span-3 text-slate-700">Means an organization, company, employer, fleet operator, logistics provider, security organization or other entity using Beeppee for business purposes.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Content</dt><dd class="sm:col-span-3 text-slate-700">Means information, data, audio, media, text, feedback or other material processed through the Services.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Device</dt><dd class="sm:col-span-3 text-slate-700">Means a smartphone, tablet, tracker, vehicle device or other device used to access or provide information to Beeppee.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Geofence</dt><dd class="sm:col-span-3 text-slate-700">Means a virtual geographic boundary created through Beeppee.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Location Information</dt><dd class="sm:col-span-3 text-slate-700">Means information relating to the current, previous or estimated location of a person, vehicle, Device, item or other monitored object.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Panic Alert</dt><dd class="sm:col-span-3 text-slate-700">Means a feature intended to notify designated persons or systems of a user's stated emergency or distress.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">Services</dt><dd class="sm:col-span-3 text-slate-700">Means all Beeppee products, applications, technology, features and services made available from time to time.</dd></div>
          <div class="py-3 grid sm:grid-cols-4 gap-2"><dt class="font-semibold text-slate-900 sm:col-span-1">User / you / your</dt><dd class="sm:col-span-3 text-slate-700">Means an individual or organization using the Services.</dd></div>
        </dl>
      </section>
 
    
      <section id="s3" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">3. About Beeppee</h2>
        <p class="text-sm text-slate-700 mb-3">3.1 Beeppee is a technology-enabled tracking, monitoring and connected-services platform.</p>
        <p class="text-sm text-slate-700 mb-2">3.2 Depending on the features available, Beeppee may allow users to:</p>
        <div class="grid sm:grid-cols-2 gap-2 mb-4">
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Locate persons with appropriate authorization</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Locate vehicles</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Locate items and assets</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Create Geofences</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Receive movement and location alerts</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Create and share trips</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Use Panic Alerts</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Schedule AI-powered events</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Generate audio or other media</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Access logistics services</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Access smart ride-hailing functionality</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Use security, surveillance and detection tools</div>
          <div class="bg-slate-50 rounded-lg px-3 py-2 text-sm">Interact with participating partners and franchise services</div>
        </div>
        <p class="text-sm text-slate-700">3.3 Beeppee may introduce, modify, suspend or discontinue features subject to applicable law.</p>
      </section>
 
      
      <section id="s4" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">4. Eligibility and Age Requirements</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Beeppee is intended for persons aged 18 years and above.</li>
          <li>Users under 18 may be subject to additional safeguards, parental or guardian authorization, age verification or other requirements under applicable law.</li>
          <li>Where processing of a minor's information relies on consent and applicable law requires parental or guardian consent, the required consent must be obtained before the relevant processing takes place.</li>
          <li>Beeppee may request information or take reasonable steps to verify age and, where applicable, parental or guardian authorization.</li>
          <li>A parent or guardian permitting a minor to use Beeppee is responsible for appropriate supervision and for ensuring compliance with applicable law.</li>
          <li>A minor must not use Beeppee to secretly track another person or otherwise circumvent these Terms or applicable law.</li>
        </ol>
      </section>
 
      
      <section id="s5" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">5. Account Registration and Security</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700 mb-3">
          <li>Certain Services require an Account.</li>
          <li>You must provide accurate and current information.</li>
          <li>You must protect your password, PIN, verification code and other authentication credentials.</li>
          <li>You must notify Beeppee promptly if you suspect unauthorized access.</li>
        </ol>
        <p class="text-sm font-medium text-slate-800 mb-2">5.5 You must not:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Create an account using another person's identity without authorization</li>
          <li>Sell or transfer your Account without Beeppee's authorization</li>
          <li>Share authentication credentials irresponsibly</li>
          <li>Knowingly permit unauthorized access</li>
        </ul>
        <p class="text-sm text-slate-700">5.6 Beeppee may require additional verification for security, fraud prevention, age verification or legal compliance.</p>
      </section>
 
      
      <section id="s6" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">6. Use of Tracking and Location Services</h2>
        <p class="text-sm text-slate-700 mb-3">6.1 Beeppee may use GPS, cellular networks, Wi-Fi, Bluetooth, device sensors, internet connectivity and other technologies.</p>
        <p class="text-sm text-slate-700 mb-3">6.2 Location information may be delayed, unavailable or inaccurate.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">6.3 Factors affecting accuracy may include:</p>
        <div class="flex flex-wrap gap-2 mb-4">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">GPS limitations</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Poor network coverage</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Indoor environments</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Physical obstructions</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Weather</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Battery levels</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Device permissions</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">OS restrictions</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Connectivity</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Telecom networks</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Hardware malfunction</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Interference</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Software errors</span>
        </div>
        <p class="text-sm text-slate-700 mb-3">6.4 Beeppee does not guarantee continuous or precise location information.</p>
        <p class="text-sm text-slate-700 bg-red-50 border border-red-200 rounded-lg p-3">6.5 You must not rely solely on Beeppee where failure or delay could cause death, serious injury, significant property loss or other serious harm.</p>
      </section>
 
     
      <section id="s7" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">7. People Tracking</h2>
        <p class="text-sm text-slate-700 mb-3">7.1 You may only use Beeppee to track or monitor another person where you have appropriate legal authority, consent or another lawful basis recognized by applicable law.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">7.2 You must not use Beeppee to:</p>
        <div class="flex flex-wrap gap-2 mb-4">
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Stalk</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Secretly monitor</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Harass</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Intimidate</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Threaten</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Control</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Unlawfully surveil</span>
          <span class="text-xs bg-red-50 text-red-700 border border-red-200 px-3 py-1 rounded-full">Track without authorization</span>
        </div>
        <p class="text-sm font-medium text-slate-800 mb-2">7.3 This requirement applies regardless of your relationship with the person being tracked, including:</p>
        <p class="text-sm text-slate-700 mb-3">Spouses, partners, family members, children, employees, domestic workers, drivers, contractors, customers, passengers and other individuals.</p>
        <p class="text-sm text-slate-700">7.4 Further requirements are contained in the Beeppee Tracking &amp; Consent Policy, which forms part of these Terms.</p>
      </section>
 
     
      <section id="s8" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">8. Vehicles, Assets and Items</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>You may track a vehicle, asset or item where you own it or have lawful authority to monitor it.</li>
          <li>If another person operates or uses the vehicle or asset, you are responsible for satisfying applicable privacy, employment and notification requirements.</li>
          <li>Installing or activating a tracking device does not itself establish that tracking another person is lawful.</li>
        </ol>
      </section>
 
      
      <section id="s9" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">9. Smart Geofencing and Alerts</h2>
        <p class="text-sm text-slate-700 mb-2">9.1 Beeppee may permit you to create Geofences.</p>
        <p class="text-sm text-slate-700 mb-2">9.2 Beeppee may generate an alert when a monitored Device, person, vehicle or item enters or leaves a Geofence.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">9.3 Alerts may be:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Delayed</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Duplicated</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Inaccurate</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Incomplete</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Unavailable</span>
        </div>
        <p class="text-sm text-slate-700">9.4 You are responsible for configuring Geofences appropriately.</p>
      </section>
 
    
      <section id="s10" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">10. Panic, Emergency and Safety Features</h2>
        <p class="text-sm text-slate-700 mb-2">10.1 Beeppee may provide Panic Alerts, emergency notifications, safety tools and related features.</p>
        <p class="text-sm text-slate-700 mb-2">10.2 These features are communication and technology tools and are not emergency-response services.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">10.3 Beeppee does not guarantee:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Delivery of an alert</li>
          <li>Immediate delivery</li>
          <li>Recipient response</li>
          <li>Emergency-service response</li>
          <li>Accurate location</li>
          <li>Device availability</li>
          <li>Recovery of a person or property</li>
        </ul>
        <p class="text-sm text-slate-700 mb-2">10.4 False, abusive or deliberately misleading Panic Alerts are prohibited.</p>
        <p class="text-sm text-slate-700 bg-amber-50 border border-amber-200 rounded-lg p-3">10.5 Where immediate assistance is required, users should contact the appropriate emergency service or authority directly.</p>
      </section>
 
    
      <section id="s11" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">11. Trip and Location Sharing</h2>
        <p class="text-sm text-slate-700 mb-2">11.1 Beeppee may allow users to create and share trip or location links.</p>
        <p class="text-sm text-slate-700 mb-2">11.2 You are responsible for selecting appropriate recipients.</p>
        <p class="text-sm text-slate-700 mb-3">11.3 You must protect private links and revoke them when no longer required.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">11.4 You must not:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700">
          <li>Publicly publish another person's location without authorization</li>
          <li>Sell or distribute private location links</li>
          <li>Use a link for stalking or harassment</li>
          <li>Share confidential information obtained from another user's Account</li>
          <li>Knowingly provide a private link to an unauthorized person</li>
        </ul>
      </section>
 
    
      <section id="s12" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">12. Logistics and Smart Ride-Hailing</h2>
        <p class="text-sm text-slate-700 mb-2">12.1 Beeppee may facilitate logistics, transportation and smart ride-hailing services.</p>
        <p class="text-sm text-slate-700 mb-3">12.2 Where a third-party provider performs the service, that provider may have separate terms.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">12.3 Beeppee may facilitate:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Requests</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Matching</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Journey tracking</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Communications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Location sharing</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Payment</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Notifications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Service-status information</span>
        </div>
        <p class="text-sm text-slate-700">12.4 Beeppee does not guarantee the conduct, safety, qualifications, availability or performance of an independent third-party provider except where Beeppee itself is legally responsible for the relevant service.</p>
      </section>
 
    
      <section id="s13" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">13. AI-Powered Features</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Beeppee may provide AI-powered scheduling, recommendations, alerts, classifications, summaries or generated media.</li>
          <li>AI-generated information may be inaccurate or incomplete.</li>
          <li>AI features are not substitutes for professional, medical, legal, security or emergency advice.</li>
          <li>Users remain responsible for decisions made using AI-generated information.</li>
        </ol>
      </section>
 
    
      <section id="s14" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">14. Audio and Generated Media</h2>
        <p class="text-sm text-slate-700 mb-2">14.1 Beeppee may generate audio and other media automatically.</p>
        <p class="text-sm text-slate-700 mb-3">14.2 Generated media may contain errors.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">14.3 You must not use generated media to:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Impersonate another person unlawfully</li>
          <li>Commit fraud</li>
          <li>Harass</li>
          <li>Deceive</li>
          <li>Threaten</li>
          <li>Facilitate unlawful activity</li>
        </ul>
        <p class="text-sm text-slate-700">14.4 If Beeppee later introduces user-uploaded media, additional terms may apply.</p>
      </section>
 
    
      <section id="s15" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">15. Third-Party Services and Partners</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Beeppee may integrate with third parties, including payment processors, mapping providers, cloud providers, telecommunications providers, logistics operators, ride-hailing providers, security providers and other partners.</li>
          <li>Third parties may have separate terms and privacy policies.</li>
          <li>Beeppee may share information reasonably necessary to provide a requested third-party service, subject to applicable law and the Privacy Policy.</li>
        </ol>
      </section>
 
    
      <section id="s16" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">16. Pay-As-You-Go Services and Beeppee Credits</h2>
        <p class="text-sm text-slate-700 mb-2">16.1 Beeppee may operate on a pay-as-you-go model.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">16.2 Chargeable activity may include:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Tracking requests</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Notifications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Alerts</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Partner engagements</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Franchise services</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Logistics services</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Mobility services</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Other chargeable features</span>
        </div>
        <p class="text-sm text-slate-700 mb-2">16.3 Where Credits are used, the relevant amount may be deducted when a chargeable feature is initiated, processed or delivered.</p>
        <p class="text-sm text-slate-700 mb-2">16.4 Applicable charges should be displayed or communicated through the relevant service interface where reasonably practicable.</p>
        <p class="text-sm text-slate-700">16.5 Beeppee may change pricing prospectively, subject to applicable law and any required notice.</p>
      </section>
 
    
      <section id="s17" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">17. Payments</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Payments may be processed by third-party providers including Flutterwave.</li>
          <li>You authorize applicable charges arising from Services you request.</li>
          <li>You must provide accurate payment information.</li>
          <li>Payment processors may apply their own terms and privacy policies.</li>
        </ol>
      </section>
 
    
      <section id="s18" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">18. Refunds, Reversals and Failed Transactions</h2>
        <p class="text-sm text-slate-700 mb-2">18.1 Specific services may have specific refund rules.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">18.2 Unless otherwise stated:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Completed service charges may not be refundable</li>
          <li>Credits may not be exchangeable for cash</li>
          <li>Credits may not be transferred unless Beeppee permits transfer</li>
          <li>Duplicate or erroneous charges may be reviewed</li>
          <li>Refunds required by law will be provided</li>
        </ul>
        <p class="text-sm text-slate-700 mb-3">18.3 Nothing in these Terms excludes a mandatory consumer right or remedy.</p>
        <div class="grid sm:grid-cols-2 gap-3">
          <div class="bg-slate-50 rounded-lg p-3 text-sm"><span class="font-medium text-slate-800">18.4 Credit expiry:</span> [Insert policy — e.g., Credits do not expire / Credits expire after X months, subject to applicable law]</div>
          <div class="bg-slate-50 rounded-lg p-3 text-sm"><span class="font-medium text-slate-800">18.5 Unused Credits after deactivation:</span> [Insert policy]</div>
        </div>
      </section>
 
    
      <section id="s19" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">19. Acceptable Use and Prohibited Activities</h2>
        <p class="text-sm text-slate-700 mb-3">You must not use Beeppee to:</p>
        <div class="grid sm:grid-cols-2 gap-2 mb-4">
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">1. Stalk or harass another person</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">2. Unlawfully track another person</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">3. Conduct unauthorized surveillance</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">4. Access another person's Account</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">5. Impersonate another person</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">6. Commit fraud</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">7. Misuse Panic Alerts</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">8. Submit false emergency reports</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">9. Distribute confidential location information without authorization</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">10. Interfere with Beeppee infrastructure</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">11. Introduce malware</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">12. Bypass security controls</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">13. Scrape or systematically extract data</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">14. Reverse engineer except where legally permitted</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">15. Infringe intellectual property</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">16. Facilitate an illegal activity</div>
          <div class="bg-red-50 border border-red-100 rounded-lg px-3 py-2 text-sm text-red-800">17. Violate applicable law</div>
        </div>
        <p class="text-sm text-slate-700">Beeppee may investigate suspected violations and take appropriate action.</p>
      </section>
 
    
      <section id="s20" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">20. Confidentiality and Information Obtained Through Beeppee</h2>
        <p class="text-sm text-slate-700 mb-2">20.1 Information obtained through Beeppee may be confidential or private.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">20.2 This may include:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Live location</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Location history</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Trip information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Panic Alerts</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Emergency information</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Account credentials</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Private communications</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Shared links</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Another user's personal information</span>
        </div>
        <p class="text-sm text-slate-700">20.3 You must not disclose such information to an unauthorized person.</p>
      </section>
 
    
      <section id="s21" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">21. Intellectual Property</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Beeppee and its licensors retain all rights in the application, software, technology, trademarks, designs, interfaces, databases, algorithms and documentation.</li>
          <li>Subject to these Terms, Beeppee grants you a limited, non-exclusive, non-transferable, non-sublicensable and revocable right to use the Services for their intended purposes.</li>
          <li>You may not reproduce, modify, distribute, sell, sublicense or commercially exploit Beeppee's proprietary materials without authorization.</li>
        </ol>
      </section>
 
    
      <section id="s22" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">22. User Feedback</h2>
        <p class="text-sm text-slate-700">22.1 If you provide feedback or suggestions, Beeppee may use that feedback without compensation, provided that such use complies with applicable privacy obligations.</p>
      </section>
 
    
      <section id="s23" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">23. Service Availability and Technical Limitations</h2>
        <p class="text-sm text-slate-700 mb-2">23.1 Beeppee aims to provide reliable Services but does not guarantee uninterrupted availability.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">23.2 Services may be interrupted by:</p>
        <div class="flex flex-wrap gap-2">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Maintenance</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Software updates</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Network failures</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">GPS limitations</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Power failures</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Device failures</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Third-party failures</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Cybersecurity incidents</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Government restrictions</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Force majeure events</span>
        </div>
      </section>
 
    
      <section id="s24" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">24. Safety and Recovery Disclaimer</h2>
        <p class="text-sm text-slate-700 mb-2">24.1 Beeppee is a technology platform.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">24.2 Beeppee does not guarantee prevention or recovery of:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Theft</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Kidnapping</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Accidents</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Injury</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Loss</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Disappearance</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Unauthorized access</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Property loss</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Criminal activity</span>
        </div>
        <p class="text-sm text-slate-700">24.3 Beeppee does not guarantee that a person, vehicle or item will be located or recovered.</p>
      </section>
 
    
      <section id="s25" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">25. Warranties and Disclaimers</h2>
        <p class="text-sm text-slate-700 mb-2">25.1 To the maximum extent permitted by law, Services are provided on an "as available" basis.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">25.2 Beeppee does not guarantee that:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Location information will always be accurate</li>
          <li>Alerts will always arrive</li>
          <li>Services will always be available</li>
          <li>AI output will always be accurate</li>
          <li>Third-party services will remain available</li>
          <li>Services will meet every particular requirement</li>
        </ul>
        <p class="text-sm text-slate-700">25.3 Nothing in these Terms excludes a right, warranty or remedy that cannot lawfully be excluded.</p>
      </section>
 
    
      <section id="s26" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">26. Limitation of Liability</h2>
        <p class="text-sm text-slate-700 mb-2">26.1 To the maximum extent permitted by applicable law, Beeppee will not be liable for indirect, incidental, special, consequential or punitive loss arising from use of the Services.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">26.2 This may include losses associated with:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Inaccurate location</li>
          <li>Delayed alerts</li>
          <li>Device failure</li>
          <li>Network failure</li>
          <li>Third-party failure</li>
          <li>Reliance on AI output</li>
          <li>Failure to recover a person, vehicle or item</li>
        </ul>
        <p class="text-sm text-slate-700">26.3 Nothing in this clause excludes or limits liability to the extent such exclusion or limitation is prohibited by law.</p>
      </section>
 
    
      <section id="s27" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">27. Indemnification</h2>
        <p class="text-sm text-slate-700 mb-2">27.1 To the extent permitted by law, you agree to indemnify Beeppee and its officers, employees, affiliates, contractors and service providers against claims arising from:</p>
        <ul class="list-disc list-outside pl-5 space-y-1.5 text-sm text-slate-700 mb-3">
          <li>Your unlawful use of Beeppee</li>
          <li>Violation of these Terms</li>
          <li>Unauthorized tracking</li>
          <li>Misuse of another person's information</li>
          <li>Infringement of third-party rights</li>
          <li>Fraud</li>
          <li>Violation of law</li>
        </ul>
        <p class="text-sm text-slate-700">27.2 This does not require you to indemnify Beeppee for liability caused by Beeppee's own unlawful conduct where such liability cannot lawfully be transferred.</p>
      </section>
 
    
      <section id="s28" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">28. Suspension and Termination</h2>
        <p class="text-sm text-slate-700 mb-2">28.1 You may deactivate your Account through the functionality made available in the application.</p>
        <p class="text-sm font-medium text-slate-800 mb-2">28.2 Beeppee may suspend or terminate access where reasonably necessary because of:</p>
        <div class="flex flex-wrap gap-2 mb-3">
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Violation of these Terms</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Unlawful activity</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Fraud</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Abuse</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Security risks</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Misuse of tracking</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Misuse of emergency features</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Non-payment</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Regulatory requirements</span>
          <span class="text-xs bg-slate-100 text-slate-700 px-3 py-1 rounded-full">Conduct threatening users or Beeppee</span>
        </div>
        <p class="text-sm text-slate-700">28.3 Where reasonably practicable, Beeppee may provide notice before termination or suspension.</p>
      </section>
 
    
      <section id="s29" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">29. Effect of Termination</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Following termination, your right to use the Services may end.</li>
          <li>Certain information may be retained where required or permitted by law.</li>
          <li>Transaction, security, fraud-prevention and legal records may be retained for appropriate periods.</li>
          <li>Information already lawfully shared with third parties may remain subject to their retention practices.</li>
        </ol>
      </section>
 
    
      <section id="s30" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">30. Privacy</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Your use of Beeppee is governed by the Beeppee Privacy Policy.</li>
          <li>The Privacy Policy forms part of these Terms.</li>
          <li>The Privacy Policy explains how Beeppee processes personal information, including location and movement information.</li>
        </ol>
      </section>
 
    
      <section id="s31" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">31. Complaints and Customer Support</h2>
        <p class="text-sm text-slate-700 mb-3">31.1 Questions, complaints and service concerns should first be directed to:</p>
        <div class="flex flex-wrap gap-4 mb-3">
          <div class="bg-brand-light/60 rounded-lg px-4 py-2 text-sm font-medium text-brand-dark">Email: info@beeppee.com</div>
          <div class="bg-brand-light/60 rounded-lg px-4 py-2 text-sm font-medium text-brand-dark">Telephone: +234 916 338 5136</div>
        </div>
        <p class="text-sm text-slate-700 mb-2">31.2 Beeppee will make reasonable efforts to investigate legitimate complaints.</p>
        <p class="text-sm text-slate-700">31.3 Nothing in this clause limits any statutory right or regulatory remedy available to a consumer.</p>
      </section>
 
    
      <section id="s32" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">32. Changes to These Terms</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>Beeppee may update these Terms.</li>
          <li>Material changes may be communicated through the application, website, email or other reasonable means.</li>
          <li>The updated Terms will state their effective date.</li>
          <li>Continued use after the effective date constitutes acceptance to the extent permitted by applicable law.</li>
        </ol>
      </section>
 
    
      <section id="s33" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">33. Governing Law and Dispute Resolution</h2>
        <ol class="list-decimal list-outside pl-5 space-y-2 text-sm leading-relaxed text-slate-700">
          <li>These Terms are governed by the laws of the Federal Republic of Nigeria.</li>
          <li>The parties should first attempt to resolve disputes through good-faith communication.</li>
          <li>Where appropriate, the parties may use mediation or another mutually agreed alternative dispute-resolution process before commencing court proceedings.</li>
          <li>Nothing in this clause prevents a consumer from exercising a mandatory statutory right or seeking relief from a competent regulator or court.</li>
          <li>Subject to mandatory legal rights, disputes shall be determined by a court of competent jurisdiction in Nigeria.</li>
        </ol>
      </section>
 
    
      <section id="s34" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">34. Severability</h2>
        <p class="text-sm text-slate-700 mb-2">If any provision is unlawful, invalid or unenforceable, it shall be modified or interpreted to the minimum extent necessary where legally permissible.</p>
        <p class="text-sm text-slate-700">The remaining provisions remain effective.</p>
      </section>
 
    
      <section id="s35" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">35. Entire Agreement</h2>
        <p class="text-sm text-slate-700">These Terms, the Privacy Policy, the Tracking &amp; Consent Policy and any expressly incorporated service-specific terms constitute the agreement concerning use of Beeppee.</p>
      </section>
 
    
      <section id="s36" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">36. No Waiver</h2>
        <p class="text-sm text-slate-700">Failure to enforce a provision does not waive Beeppee's right to enforce it later.</p>
      </section>
 
    
      <section id="s37" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">37. Assignment</h2>
        <p class="text-sm text-slate-700 mb-2">You may not transfer your rights or obligations under these Terms without Beeppee's written consent, except where otherwise permitted by law.</p>
        <p class="text-sm text-slate-700">Beeppee may transfer its rights and obligations as part of a corporate restructuring, merger, acquisition, financing or sale of relevant business assets, subject to applicable law.</p>
      </section>
 
    
      <section id="s38" class="scroll-mt-24 bg-white border border-slate-200 rounded-2xl p-6 sm:p-8">
        <h2 class="text-xl font-bold text-slate-900 mb-4">38. Contact Information</h2>
        <div class="grid sm:grid-cols-2 gap-4 text-sm">
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Registered Company</p><p class="font-medium text-slate-800">[Insert CAC-registered name]</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">CAC Number</p><p class="font-medium text-slate-800">[Insert]</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Registered Address</p><p class="font-medium text-slate-800">[Insert]</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Email</p><p class="font-medium text-slate-800">info@beeppee.com</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Telephone</p><p class="font-medium text-slate-800">+234 916 338 5136</p></div>
          <div><p class="text-slate-400 text-xs uppercase tracking-wide">Website</p><p class="font-medium text-slate-800">[Insert]</p></div>
        </div>
      </section>
 

      <div class="bg-slate-900 text-white rounded-2xl p-6 sm:p-8">
        <p class="text-xs uppercase tracking-widest text-amber-300 font-semibold mb-2">Important Safety Notice</p>
        <p class="text-sm text-slate-200 leading-relaxed">
          Beeppee is a technology platform and not an emergency-response organization. Do not rely solely
          on Beeppee for emergency response, medical assistance, law-enforcement response, personal
          protection, theft prevention or recovery of a person or property. Where immediate assistance is
          required, contact the appropriate emergency or professional service.
        </p>
      </div>
 
        </main>
    </div>
    <Footer/>
      
    </>
  )
}

export default Terms
